module.exports = __webpack_public_path__ + "static/media/ZM.276e06df.svg";